var _g, _g2, _g3, _g4, _g5, _path, _path2, _g6, _g7, _path3, _g8, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _g9, _path12, _path13, _path14, _path15, _path16, _g0, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneCase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 408,
    height: 807,
    viewBox: "0 0 408 807",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9553_32422)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_9553_32422)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 116.121,
    width: 2,
    height: 25,
    fill: "#8B888F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 116.121,
    width: 2,
    height: 25,
    fill: "url(#paint0_linear_9553_32422)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_9553_32422)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 120.121C6 117.737 4 116.121 4 116.121L9.10557 113.334C10.4354 112.669 12 113.636 12 115.123V120.121V137.121V142.118C12 143.605 10.4354 144.572 9.10557 143.907L4 141.121C4 141.121 6 139.504 6 137.121V120.121Z",
    fill: "#BABABA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 120.121C6 117.737 4 116.121 4 116.121L9.10557 113.334C10.4354 112.669 12 113.636 12 115.123V120.121V137.121V142.118C12 143.605 10.4354 144.572 9.10557 143.907L4 141.121C4 141.121 6 139.504 6 137.121V120.121Z",
    fill: "url(#paint1_linear_9553_32422)",
    fillOpacity: 0.9
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9553_32422)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_9553_32422)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 85,
    transform: "matrix(-1 0 0 1 400 192.381)",
    fill: "#8B888F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 85,
    transform: "matrix(-1 0 0 1 400 192.381)",
    fill: "url(#paint2_linear_9553_32422)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_9553_32422)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M398 196.381C398 193.997 400 192.381 400 192.381L394.894 189.594C393.565 188.929 392 189.896 392 191.383V196.381V273.381V278.378C392 279.865 393.565 280.832 394.894 280.167L400 277.381C400 277.381 398 275.764 398 273.381V196.381Z",
    fill: "#BABABA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M398 196.381C398 193.997 400 192.381 400 192.381L394.894 189.594C393.565 188.929 392 189.896 392 191.383V196.381V273.381V278.378C392 279.865 393.565 280.832 394.894 280.167L400 277.381C400 277.381 398 275.764 398 273.381V196.381Z",
    fill: "url(#paint3_linear_9553_32422)",
    fillOpacity: 0.9
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_9553_32422)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_9553_32422)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 174.005,
    width: 2,
    height: 50,
    fill: "#8B888F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 174.005,
    width: 2,
    height: 50,
    fill: "url(#paint4_linear_9553_32422)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_9553_32422)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 178.005C6 175.621 4 174.005 4 174.005L9.10557 171.218C10.4354 170.553 12 171.52 12 173.007V178.005V220.005V225.002C12 226.489 10.4354 227.456 9.10557 226.791L4 224.005C4 224.005 6 222.388 6 220.005V178.005Z",
    fill: "#BABABA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 178.005C6 175.621 4 174.005 4 174.005L9.10557 171.218C10.4354 170.553 12 171.52 12 173.007V178.005V220.005V225.002C12 226.489 10.4354 227.456 9.10557 226.791L4 224.005C4 224.005 6 222.388 6 220.005V178.005Z",
    fill: "url(#paint5_linear_9553_32422)",
    fillOpacity: 0.9
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_9553_32422)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_i_9553_32422)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 247.508,
    width: 2,
    height: 50,
    fill: "#8B888F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 247.508,
    width: 2,
    height: 50,
    fill: "url(#paint6_linear_9553_32422)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_i_9553_32422)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 251.508C6 249.124 4 247.508 4 247.508L9.10557 244.722C10.4354 244.057 12 245.024 12 246.511V251.508V293.508V298.505C12 299.992 10.4354 300.959 9.10557 300.294L4 297.508C4 297.508 6 295.892 6 293.508V251.508Z",
    fill: "#BABABA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 251.508C6 249.124 4 247.508 4 247.508L9.10557 244.722C10.4354 244.057 12 245.024 12 246.511V251.508V293.508V298.505C12 299.992 10.4354 300.959 9.10557 300.294L4 297.508C4 297.508 6 295.892 6 293.508V251.508Z",
    fill: "url(#paint7_linear_9553_32422)",
    fillOpacity: 0.9
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_ii_9553_32422)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M397.226 80.8022C397.244 83.9863 397.244 87.166 397.244 90.35V716.569C397.244 719.753 397.244 722.932 397.226 726.117C397.208 728.794 397.177 731.477 397.106 734.154C396.95 739.994 396.604 745.883 395.569 751.656C394.517 757.518 392.798 762.976 390.085 768.3C387.42 773.531 383.943 778.314 379.791 782.462C375.639 786.619 370.856 790.096 365.62 792.76C360.3 795.469 354.847 797.188 348.989 798.24C343.212 799.275 337.323 799.626 331.484 799.781C328.801 799.852 326.124 799.883 323.441 799.901C320.262 799.919 317.078 799.919 313.894 799.919H222.181C221.546 798.82 220.358 798.081 218.998 798.081H185.002C183.642 798.081 182.454 798.82 181.819 799.919H90.1064C86.9268 799.919 83.7427 799.919 80.563 799.901C77.8808 799.883 75.1985 799.852 72.5207 799.781C66.681 799.626 60.788 799.275 55.0149 798.24C49.1574 797.188 43.7041 795.469 38.384 792.76C33.1482 790.096 28.361 786.619 24.2133 782.462C20.0611 778.314 16.5839 773.531 13.9194 768.3C11.2061 762.976 9.48746 757.518 8.43498 751.656C7.40027 745.883 7.05388 739.994 6.89845 734.154C6.8274 731.477 6.79187 728.794 6.77855 726.117C6.75635 722.932 6.75635 719.753 6.75635 716.569V90.35C6.75635 87.166 6.75635 83.9863 6.77855 80.8022C6.79187 78.1244 6.8274 75.4422 6.89845 72.7643C7.05388 66.9246 7.40027 61.0361 8.43498 55.263C9.48746 49.4011 11.2061 43.9478 13.9194 38.6232C16.5839 33.3874 20.0611 28.6047 24.2133 24.4525C28.361 20.3047 33.1482 16.8231 38.384 14.1586C43.7041 11.4497 49.1574 9.73111 55.0149 8.67864C60.788 7.63948 66.681 7.29754 72.5207 7.13767C75.1985 7.06661 77.8808 7.03553 80.563 7.01776C83.7427 7 86.9268 7 90.1064 7H189.856C193.041 7 196.225 7 199.404 7.01776C200.27 7.0235 201.136 7.03063 202.002 7.04004C202.868 7.03063 203.734 7.0235 204.6 7.01776C207.78 7 210.964 7 214.144 7H313.894C317.078 7 320.262 7 323.441 7.01776C326.124 7.03553 328.801 7.06661 331.484 7.13767C337.323 7.29754 343.212 7.63948 348.989 8.67864C354.847 9.73111 360.3 11.4497 365.62 14.1586C370.856 16.8231 375.639 20.3047 379.791 24.4525C383.943 28.6047 387.42 33.3874 390.085 38.6232C392.798 43.9478 394.517 49.4011 395.569 55.263C396.604 61.0361 396.95 66.9246 397.106 72.7643C397.177 75.4422 397.208 78.1244 397.226 80.8022Z",
    fill: "#9C9C9C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M397.226 80.8022C397.244 83.9863 397.244 87.166 397.244 90.35V716.569C397.244 719.753 397.244 722.932 397.226 726.117C397.208 728.794 397.177 731.477 397.106 734.154C396.95 739.994 396.604 745.883 395.569 751.656C394.517 757.518 392.798 762.976 390.085 768.3C387.42 773.531 383.943 778.314 379.791 782.462C375.639 786.619 370.856 790.096 365.62 792.76C360.3 795.469 354.847 797.188 348.989 798.24C343.212 799.275 337.323 799.626 331.484 799.781C328.801 799.852 326.124 799.883 323.441 799.901C320.262 799.919 317.078 799.919 313.894 799.919H222.181C221.546 798.82 220.358 798.081 218.998 798.081H185.002C183.642 798.081 182.454 798.82 181.819 799.919H90.1064C86.9268 799.919 83.7427 799.919 80.563 799.901C77.8808 799.883 75.1985 799.852 72.5207 799.781C66.681 799.626 60.788 799.275 55.0149 798.24C49.1574 797.188 43.7041 795.469 38.384 792.76C33.1482 790.096 28.361 786.619 24.2133 782.462C20.0611 778.314 16.5839 773.531 13.9194 768.3C11.2061 762.976 9.48746 757.518 8.43498 751.656C7.40027 745.883 7.05388 739.994 6.89845 734.154C6.8274 731.477 6.79187 728.794 6.77855 726.117C6.75635 722.932 6.75635 719.753 6.75635 716.569V90.35C6.75635 87.166 6.75635 83.9863 6.77855 80.8022C6.79187 78.1244 6.8274 75.4422 6.89845 72.7643C7.05388 66.9246 7.40027 61.0361 8.43498 55.263C9.48746 49.4011 11.2061 43.9478 13.9194 38.6232C16.5839 33.3874 20.0611 28.6047 24.2133 24.4525C28.361 20.3047 33.1482 16.8231 38.384 14.1586C43.7041 11.4497 49.1574 9.73111 55.0149 8.67864C60.788 7.63948 66.681 7.29754 72.5207 7.13767C75.1985 7.06661 77.8808 7.03553 80.563 7.01776C83.7427 7 86.9268 7 90.1064 7H189.856C193.041 7 196.225 7 199.404 7.01776C200.27 7.0235 201.136 7.03063 202.002 7.04004C202.868 7.03063 203.734 7.0235 204.6 7.01776C207.78 7 210.964 7 214.144 7H313.894C317.078 7 320.262 7 323.441 7.01776C326.124 7.03553 328.801 7.06661 331.484 7.13767C337.323 7.29754 343.212 7.63948 348.989 8.67864C354.847 9.73111 360.3 11.4497 365.62 14.1586C370.856 16.8231 375.639 20.3047 379.791 24.4525C383.943 28.6047 387.42 33.3874 390.085 38.6232C392.798 43.9478 394.517 49.4011 395.569 55.263C396.604 61.0361 396.95 66.9246 397.106 72.7643C397.177 75.4422 397.208 78.1244 397.226 80.8022Z",
    fill: "url(#paint8_linear_9553_32422)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M397.226 80.8022C397.244 83.9863 397.244 87.166 397.244 90.35V716.569C397.244 719.753 397.244 722.932 397.226 726.117C397.208 728.794 397.177 731.477 397.106 734.154C396.95 739.994 396.604 745.883 395.569 751.656C394.517 757.518 392.798 762.976 390.085 768.3C387.42 773.531 383.943 778.314 379.791 782.462C375.639 786.619 370.856 790.096 365.62 792.76C360.3 795.469 354.847 797.188 348.989 798.24C343.212 799.275 337.323 799.626 331.484 799.781C328.801 799.852 326.124 799.883 323.441 799.901C320.262 799.919 317.078 799.919 313.894 799.919H222.181C221.546 798.82 220.358 798.081 218.998 798.081H185.002C183.642 798.081 182.454 798.82 181.819 799.919H90.1064C86.9268 799.919 83.7427 799.919 80.563 799.901C77.8808 799.883 75.1985 799.852 72.5207 799.781C66.681 799.626 60.788 799.275 55.0149 798.24C49.1574 797.188 43.7041 795.469 38.384 792.76C33.1482 790.096 28.361 786.619 24.2133 782.462C20.0611 778.314 16.5839 773.531 13.9194 768.3C11.2061 762.976 9.48746 757.518 8.43498 751.656C7.40027 745.883 7.05388 739.994 6.89845 734.154C6.8274 731.477 6.79187 728.794 6.77855 726.117C6.75635 722.932 6.75635 719.753 6.75635 716.569V90.35C6.75635 87.166 6.75635 83.9863 6.77855 80.8022C6.79187 78.1244 6.8274 75.4422 6.89845 72.7643C7.05388 66.9246 7.40027 61.0361 8.43498 55.263C9.48746 49.4011 11.2061 43.9478 13.9194 38.6232C16.5839 33.3874 20.0611 28.6047 24.2133 24.4525C28.361 20.3047 33.1482 16.8231 38.384 14.1586C43.7041 11.4497 49.1574 9.73111 55.0149 8.67864C60.788 7.63948 66.681 7.29754 72.5207 7.13767C75.1985 7.06661 77.8808 7.03553 80.563 7.01776C83.7427 7 86.9268 7 90.1064 7H189.856C193.041 7 196.225 7 199.404 7.01776C200.27 7.0235 201.136 7.03063 202.002 7.04004C202.868 7.03063 203.734 7.0235 204.6 7.01776C207.78 7 210.964 7 214.144 7H313.894C317.078 7 320.262 7 323.441 7.01776C326.124 7.03553 328.801 7.06661 331.484 7.13767C337.323 7.29754 343.212 7.63948 348.989 8.67864C354.847 9.73111 360.3 11.4497 365.62 14.1586C370.856 16.8231 375.639 20.3047 379.791 24.4525C383.943 28.6047 387.42 33.3874 390.085 38.6232C392.798 43.9478 394.517 49.4011 395.569 55.263C396.604 61.0361 396.95 66.9246 397.106 72.7643C397.177 75.4422 397.208 78.1244 397.226 80.8022Z",
    fill: "url(#paint9_radial_9553_32422)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M397.226 80.8022C397.244 83.9863 397.244 87.166 397.244 90.35V716.569C397.244 719.753 397.244 722.932 397.226 726.117C397.208 728.794 397.177 731.477 397.106 734.154C396.95 739.994 396.604 745.883 395.569 751.656C394.517 757.518 392.798 762.976 390.085 768.3C387.42 773.531 383.943 778.314 379.791 782.462C375.639 786.619 370.856 790.096 365.62 792.76C360.3 795.469 354.847 797.188 348.989 798.24C343.212 799.275 337.323 799.626 331.484 799.781C328.801 799.852 326.124 799.883 323.441 799.901C320.262 799.919 317.078 799.919 313.894 799.919H222.181C221.546 798.82 220.358 798.081 218.998 798.081H185.002C183.642 798.081 182.454 798.82 181.819 799.919H90.1064C86.9268 799.919 83.7427 799.919 80.563 799.901C77.8808 799.883 75.1985 799.852 72.5207 799.781C66.681 799.626 60.788 799.275 55.0149 798.24C49.1574 797.188 43.7041 795.469 38.384 792.76C33.1482 790.096 28.361 786.619 24.2133 782.462C20.0611 778.314 16.5839 773.531 13.9194 768.3C11.2061 762.976 9.48746 757.518 8.43498 751.656C7.40027 745.883 7.05388 739.994 6.89845 734.154C6.8274 731.477 6.79187 728.794 6.77855 726.117C6.75635 722.932 6.75635 719.753 6.75635 716.569V90.35C6.75635 87.166 6.75635 83.9863 6.77855 80.8022C6.79187 78.1244 6.8274 75.4422 6.89845 72.7643C7.05388 66.9246 7.40027 61.0361 8.43498 55.263C9.48746 49.4011 11.2061 43.9478 13.9194 38.6232C16.5839 33.3874 20.0611 28.6047 24.2133 24.4525C28.361 20.3047 33.1482 16.8231 38.384 14.1586C43.7041 11.4497 49.1574 9.73111 55.0149 8.67864C60.788 7.63948 66.681 7.29754 72.5207 7.13767C75.1985 7.06661 77.8808 7.03553 80.563 7.01776C83.7427 7 86.9268 7 90.1064 7H189.856C193.041 7 196.225 7 199.404 7.01776C200.27 7.0235 201.136 7.03063 202.002 7.04004C202.868 7.03063 203.734 7.0235 204.6 7.01776C207.78 7 210.964 7 214.144 7H313.894C317.078 7 320.262 7 323.441 7.01776C326.124 7.03553 328.801 7.06661 331.484 7.13767C337.323 7.29754 343.212 7.63948 348.989 8.67864C354.847 9.73111 360.3 11.4497 365.62 14.1586C370.856 16.8231 375.639 20.3047 379.791 24.4525C383.943 28.6047 387.42 33.3874 390.085 38.6232C392.798 43.9478 394.517 49.4011 395.569 55.263C396.604 61.0361 396.95 66.9246 397.106 72.7643C397.177 75.4422 397.208 78.1244 397.226 80.8022Z",
    fill: "url(#paint10_radial_9553_32422)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9553_32422",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 7,
    width: 392,
    height: 793
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M397.244 189.167V90.35C397.244 87.166 397.244 83.9863 397.226 80.8022C397.208 78.1244 397.177 75.4422 397.106 72.7643C396.95 66.9246 396.604 61.0361 395.569 55.263C394.517 49.4011 392.798 43.9478 390.085 38.6232C387.42 33.3874 383.943 28.6047 379.791 24.4525C375.639 20.3047 370.856 16.8231 365.62 14.1586C360.3 11.4497 354.847 9.73111 348.989 8.67864C343.212 7.63948 337.323 7.29754 331.484 7.13767C328.801 7.06661 326.124 7.03553 323.441 7.01776C320.262 7 317.078 7 313.894 7H214.144C210.964 7 207.78 7 204.6 7.01776C203.734 7.0235 202.868 7.03063 202.002 7.04004C201.136 7.03063 200.27 7.0235 199.404 7.01776C196.225 7 193.041 7 189.856 7H90.1064C86.9267 7 83.7427 7 80.563 7.01776C77.8808 7.03553 75.1985 7.06661 72.5207 7.13767C66.681 7.29754 60.788 7.63948 55.0149 8.67864C49.1574 9.73111 43.7041 11.4497 38.384 14.1586C33.1482 16.8231 28.361 20.3047 24.2133 24.4525C20.0611 28.6047 16.5839 33.3874 13.9194 38.6232C11.2061 43.9478 9.48746 49.4011 8.43498 55.263C7.40027 61.0361 7.05388 66.9246 6.89845 72.7643C6.8274 75.4422 6.79187 78.1244 6.77855 80.8022C6.75635 83.9863 6.75635 87.166 6.75635 90.35V113.826C7.3056 114.144 7.67514 114.737 7.67514 115.418V142.063C7.67514 142.743 7.3056 143.337 6.75635 143.654V170.791C7.3056 171.109 7.67514 171.703 7.67514 172.383V225.673C7.67514 226.353 7.3056 226.947 6.75635 227.265L6.75635 243.376C7.3056 243.694 7.67514 244.287 7.67514 244.968V298.258C7.67514 298.938 7.3056 299.532 6.75635 299.849V716.569C6.75635 719.753 6.75635 722.932 6.77855 726.117C6.79187 728.794 6.8274 731.477 6.89845 734.154C7.05388 739.994 7.40027 745.883 8.43498 751.656C9.48746 757.518 11.2061 762.976 13.9194 768.3C16.5839 773.531 20.0611 778.314 24.2133 782.462C28.361 786.619 33.1482 790.096 38.384 792.76C43.7041 795.469 49.1574 797.188 55.0149 798.24C60.788 799.275 66.681 799.626 72.5207 799.781C75.1985 799.852 77.8808 799.883 80.563 799.901C83.7427 799.919 86.9267 799.919 90.1064 799.919H181.105C181.846 798.811 183.109 798.081 184.543 798.081H219.457C220.891 798.081 222.154 798.811 222.895 799.919H313.894C317.078 799.919 320.262 799.919 323.441 799.901C326.124 799.883 328.801 799.852 331.484 799.781C337.323 799.626 343.212 799.275 348.989 798.24C354.847 797.188 360.3 795.469 365.62 792.76C370.856 790.096 375.639 786.619 379.791 782.462C383.943 778.314 387.42 773.531 390.085 768.3C392.798 762.976 394.517 757.518 395.569 751.656C396.604 745.883 396.95 739.994 397.106 734.154C397.177 731.477 397.208 728.794 397.226 726.117C397.244 722.932 397.244 719.753 397.244 716.569V280.555C396.694 280.237 396.325 279.643 396.325 278.963V190.759C396.325 190.079 396.694 189.485 397.244 189.167Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M397.244 189.167V90.35C397.244 87.166 397.244 83.9863 397.226 80.8022C397.208 78.1244 397.177 75.4422 397.106 72.7643C396.95 66.9246 396.604 61.0361 395.569 55.263C394.517 49.4011 392.798 43.9478 390.085 38.6232C387.42 33.3874 383.943 28.6047 379.791 24.4525C375.639 20.3047 370.856 16.8231 365.62 14.1586C360.3 11.4497 354.847 9.73111 348.989 8.67864C343.212 7.63948 337.323 7.29754 331.484 7.13767C328.801 7.06661 326.124 7.03553 323.441 7.01776C320.262 7 317.078 7 313.894 7H214.144C210.964 7 207.78 7 204.6 7.01776C203.734 7.0235 202.868 7.03063 202.002 7.04004C201.136 7.03063 200.27 7.0235 199.404 7.01776C196.225 7 193.041 7 189.856 7H90.1064C86.9267 7 83.7427 7 80.563 7.01776C77.8808 7.03553 75.1985 7.06661 72.5207 7.13767C66.681 7.29754 60.788 7.63948 55.0149 8.67864C49.1574 9.73111 43.7041 11.4497 38.384 14.1586C33.1482 16.8231 28.361 20.3047 24.2133 24.4525C20.0611 28.6047 16.5839 33.3874 13.9194 38.6232C11.2061 43.9478 9.48746 49.4011 8.43498 55.263C7.40027 61.0361 7.05388 66.9246 6.89845 72.7643C6.8274 75.4422 6.79187 78.1244 6.77855 80.8022C6.75635 83.9863 6.75635 87.166 6.75635 90.35V113.826C7.3056 114.144 7.67514 114.737 7.67514 115.418V142.063C7.67514 142.743 7.3056 143.337 6.75635 143.654V170.791C7.3056 171.109 7.67514 171.703 7.67514 172.383V225.673C7.67514 226.353 7.3056 226.947 6.75635 227.265L6.75635 243.376C7.3056 243.694 7.67514 244.287 7.67514 244.968V298.258C7.67514 298.938 7.3056 299.532 6.75635 299.849V716.569C6.75635 719.753 6.75635 722.932 6.77855 726.117C6.79187 728.794 6.8274 731.477 6.89845 734.154C7.05388 739.994 7.40027 745.883 8.43498 751.656C9.48746 757.518 11.2061 762.976 13.9194 768.3C16.5839 773.531 20.0611 778.314 24.2133 782.462C28.361 786.619 33.1482 790.096 38.384 792.76C43.7041 795.469 49.1574 797.188 55.0149 798.24C60.788 799.275 66.681 799.626 72.5207 799.781C75.1985 799.852 77.8808 799.883 80.563 799.901C83.7427 799.919 86.9267 799.919 90.1064 799.919H181.105C181.846 798.811 183.109 798.081 184.543 798.081H219.457C220.891 798.081 222.154 798.811 222.895 799.919H313.894C317.078 799.919 320.262 799.919 323.441 799.901C326.124 799.883 328.801 799.852 331.484 799.781C337.323 799.626 343.212 799.275 348.989 798.24C354.847 797.188 360.3 795.469 365.62 792.76C370.856 790.096 375.639 786.619 379.791 782.462C383.943 778.314 387.42 773.531 390.085 768.3C392.798 762.976 394.517 757.518 395.569 751.656C396.604 745.883 396.95 739.994 397.106 734.154C397.177 731.477 397.208 728.794 397.226 726.117C397.244 722.932 397.244 719.753 397.244 716.569V280.555C396.694 280.237 396.325 279.643 396.325 278.963V190.759C396.325 190.079 396.694 189.485 397.244 189.167Z",
    stroke: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9553_32422)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter9_f_9553_32422)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.8816 26.7905C34.3671 25.1177 27.2184 25.8948 20.9336 29.5234C10.6011 35.4888 5.77561 47.3295 8.24056 58.3892C9.01393 47.5083 15.0002 37.1927 25.1583 31.328C30.1277 28.4588 35.5205 26.987 40.8816 26.7905Z",
    fill: "black",
    fillOpacity: 0.9
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter10_f_9553_32422)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.963 775.81C33.4485 777.483 26.2997 776.706 20.0148 773.077C9.68238 767.112 4.85686 755.271 7.32182 744.212C8.09522 755.093 14.0815 765.408 24.2396 771.273C29.209 774.142 34.6018 775.614 39.963 775.81Z",
    fill: "black",
    fillOpacity: 0.9
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_f_9553_32422)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M363.685 26.7906C370.2 25.1177 377.349 25.8949 383.633 29.5235C393.966 35.4888 398.791 47.3293 396.327 58.3888C395.553 47.5081 389.567 37.1927 379.409 31.328C374.439 28.4589 369.047 26.987 363.685 26.7906Z",
    fill: "black",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_f_9553_32422)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M364.145 775.81C370.659 777.483 377.808 776.706 384.093 773.077C394.425 767.112 399.251 755.271 396.786 744.212C396.012 755.093 390.026 765.408 379.868 771.273C374.899 774.142 369.506 775.614 364.145 775.81Z",
    fill: "black",
    fillOpacity: 0.9
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_ddddi_9553_32422)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.188 85.86V721.059C13.188 723.826 13.188 726.589 13.2073 729.356C13.2189 731.683 13.2497 734.013 13.3115 736.34C13.4465 741.415 13.7475 746.532 14.6467 751.548C15.5612 756.642 17.0546 761.385 19.4124 766.012C21.7278 770.558 24.7494 774.714 28.3575 778.318C31.9617 781.93 36.1216 784.951 40.6713 787.267C45.2943 789.621 50.0331 791.114 55.123 792.029C60.1396 792.928 65.2604 793.233 70.3349 793.368C72.6619 793.429 74.9927 793.456 77.3234 793.472C80.0864 793.487 82.8533 793.487 85.6163 793.487H149.248H255.212H318.384C321.151 793.487 323.917 793.487 326.68 793.472C329.011 793.456 331.338 793.429 333.669 793.368C338.744 793.233 343.86 792.928 348.881 792.029C353.971 791.114 358.71 789.621 363.333 787.267C367.882 784.951 372.038 781.93 375.646 778.318C379.255 774.714 382.276 770.558 384.592 766.012C386.949 761.385 388.443 756.642 389.357 751.548C390.256 746.532 390.557 741.415 390.692 736.34C390.754 734.013 390.781 731.683 390.797 729.356C390.812 726.589 390.812 723.826 390.812 721.059V85.86C390.812 83.0931 390.812 80.3301 390.797 77.5632C390.781 75.2363 390.754 72.9055 390.692 70.5786C390.557 65.5041 390.256 60.3871 389.357 55.3705C388.443 50.2767 386.949 45.538 384.592 40.9111C382.276 36.3614 379.255 32.2053 375.646 28.5972C372.038 24.993 367.882 21.9676 363.333 19.6522C358.71 17.2983 353.971 15.8049 348.881 14.8903C343.86 13.9873 338.744 13.6902 333.669 13.5513C331.338 13.4895 329.011 13.4625 326.68 13.4471C323.917 13.4316 321.151 13.4316 318.384 13.4316H85.6163C82.8533 13.4316 80.0864 13.4316 77.3234 13.4471C74.9927 13.4625 72.6619 13.4895 70.3349 13.5513C65.2604 13.6902 60.1396 13.9873 55.123 14.8903C50.0331 15.8049 45.2943 17.2983 40.6713 19.6522C36.1216 21.9676 31.9617 24.993 28.3575 28.5972C24.7494 32.2053 21.7278 36.3614 19.4124 40.9111C17.0546 45.538 15.5612 50.2767 14.6467 55.3705C13.7475 60.3871 13.4465 65.5041 13.3115 70.5786C13.2497 72.9055 13.2189 75.2363 13.2073 77.5632C13.188 80.3301 13.188 83.0931 13.188 85.86Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2073 729.349L14.2073 729.351C14.2188 731.672 14.2496 733.996 14.3111 736.314C14.4457 741.371 14.7451 746.429 15.631 751.372C16.5305 756.382 17.9957 761.029 20.3034 765.558L19.4124 766.012L20.3035 765.558C22.5711 770.01 25.5304 774.08 29.0642 777.61L29.0653 777.612C32.5948 781.149 36.6689 784.108 41.1249 786.375L40.6713 787.267L41.1251 786.376C45.65 788.68 50.2936 790.145 55.2999 791.044C60.2425 791.93 65.3048 792.233 70.3615 792.368C72.6788 792.43 75.0022 792.456 77.3301 792.472C80.0895 792.487 82.8532 792.487 85.6163 792.487H149.248H255.212H318.384C321.151 792.487 323.914 792.487 326.674 792.472C329.002 792.456 331.321 792.43 333.643 792.368C338.699 792.233 343.758 791.93 348.705 791.044M14.2073 729.349L348.881 792.029M14.2073 729.349C14.188 726.586 14.188 723.826 14.188 721.059V85.86C14.188 83.0925 14.188 80.333 14.2073 77.5702L14.2073 77.5682M14.2073 729.349L14.2073 77.5682M348.705 791.044L348.881 792.029M348.705 791.044C348.704 791.044 348.704 791.044 348.704 791.044L348.881 792.029M348.705 791.044C353.711 790.145 358.354 788.68 362.879 786.376L363.333 787.267C358.71 789.621 353.971 791.114 348.881 792.029M14.2073 77.5682C14.2188 75.2467 14.2496 72.9233 14.3111 70.6052C14.4457 65.548 14.7451 60.4899 15.6309 55.5472L14.2073 77.5682ZM389.797 729.349C389.797 729.349 389.797 729.35 389.797 729.35L390.797 729.356L389.797 729.349ZM383.7 41.3647L383.701 41.3651L15.631 55.5469C16.5305 50.537 17.9957 45.8937 20.3034 41.3651L20.3037 41.3647C22.5712 36.909 25.5305 32.8384 29.0646 29.3044C32.5948 25.7741 36.6692 22.811 41.1249 20.5435L41.1251 20.5434C45.65 18.2393 50.2936 16.7741 55.2999 15.8746L55.3002 15.8745C60.2421 14.985 65.3034 14.6894 70.362 14.5509C72.679 14.4894 75.002 14.4625 77.3296 14.4471C80.0891 14.4316 82.853 14.4316 85.6163 14.4316H318.384C321.151 14.4316 323.915 14.4316 326.674 14.4471C329.002 14.4625 331.321 14.4894 333.642 14.5509C338.701 14.6894 343.758 14.985 348.704 15.8745L348.865 14.9769L348.704 15.8746C353.71 16.7741 358.354 18.2393 362.879 20.5434L362.879 20.5435C367.334 22.8107 371.405 25.7738 374.939 29.3044C378.473 32.8384 381.433 36.909 383.7 41.3647ZM390.797 77.5632L389.797 77.5688C389.797 77.5692 389.797 77.5695 389.797 77.5699L390.797 77.5632ZM388.373 55.5469C388.373 55.547 388.373 55.5471 388.373 55.5472L389.357 55.3705L388.373 55.5469Z",
    stroke: "black",
    strokeOpacity: 0.7,
    strokeWidth: 2
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1879 82.3411H6.75635V87.8538H13.1879V82.3411ZM13.1879 708.039H6.75635V713.552H13.1879V708.039ZM390.812 82.3411H397.244V87.8538H390.812V82.3411ZM397.244 708.039H390.812V713.552H397.244V708.039Z",
    fill: "black"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_i_9553_32422)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9443 87.4666V719.452C15.9443 722.175 15.9443 724.894 15.9633 727.617C15.9747 729.907 16.0051 732.201 16.0659 734.491C16.1988 739.485 16.495 744.521 17.3799 749.458C18.2799 754.471 19.7496 759.138 22.07 763.691C24.3486 768.165 27.3222 772.255 30.873 775.802C34.42 779.357 38.5139 782.331 42.9914 784.609C47.541 786.926 52.2046 788.395 57.2137 789.295C62.1507 790.18 67.1902 790.48 72.1842 790.613C74.4742 790.674 76.768 790.701 79.0618 790.716C81.7809 790.731 84.5038 790.731 87.223 790.731H156.254H248.205H316.777C319.5 790.731 322.223 790.731 324.942 790.716C327.236 790.701 329.526 790.674 331.82 790.613C336.814 790.48 341.849 790.18 346.79 789.295C351.799 788.395 356.463 786.926 361.012 784.609C365.49 782.331 369.58 779.357 373.131 775.802C376.682 772.255 379.655 768.165 381.934 763.691C384.254 759.138 385.724 754.471 386.624 749.458C387.509 744.521 387.805 739.485 387.938 734.491C387.999 732.201 388.025 729.907 388.04 727.617C388.056 724.894 388.056 722.175 388.056 719.452V87.4666C388.056 84.7437 388.056 82.0246 388.04 79.3016C388.025 77.0116 387.999 74.7178 387.938 72.4278C387.805 67.4339 387.509 62.3982 386.624 57.4612C385.724 52.4482 384.254 47.7847 381.934 43.2313C379.655 38.7538 376.682 34.6637 373.131 31.1129C369.58 27.5658 365.49 24.5885 361.012 22.3098C356.463 19.9933 351.799 18.5236 346.79 17.6235C341.849 16.7349 336.814 16.4424 331.82 16.3057C329.526 16.245 327.236 16.2184 324.942 16.2032C322.223 16.188 319.5 16.188 316.777 16.188H87.223C84.5038 16.188 81.7809 16.188 79.0618 16.2032C76.768 16.2184 74.4742 16.245 72.1842 16.3057C67.1902 16.4424 62.1507 16.7349 57.2137 17.6235C52.2046 18.5236 47.541 19.9933 42.9914 22.3098C38.5139 24.5885 34.42 27.5658 30.873 31.1129C27.3222 34.6637 24.3486 38.7538 22.07 43.2313C19.7496 47.7847 18.2799 52.4482 17.3799 57.4612C16.495 62.3982 16.1988 67.4339 16.0659 72.4278C16.0051 74.7178 15.9747 77.0116 15.9633 79.3016C15.9443 82.0246 15.9443 84.7437 15.9443 87.4666Z",
    fill: "black"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8877 749.546L16.8877 749.546C15.9962 744.572 15.6992 739.507 15.566 734.504L16.0659 734.491L15.566 734.504C15.5052 732.21 15.4747 729.913 15.4633 727.621C15.4443 724.896 15.4443 722.176 15.4443 719.453V719.452V87.4667V87.4658C15.4443 84.7436 15.4443 82.0232 15.4633 79.2987C15.4747 77.0061 15.5052 74.7088 15.566 72.4146L15.566 72.4145C15.6992 67.412 15.9962 62.3469 16.8877 57.373L16.8877 57.3728C17.7953 52.3181 19.279 47.6069 21.6244 43.0045C23.9269 38.48 26.9316 34.3472 30.5195 30.7593C34.1035 27.1753 38.2401 24.1668 42.7646 21.8642C47.3632 19.5227 52.0743 18.039 57.1251 17.1314C62.0994 16.236 67.1686 15.9428 72.1705 15.8059L72.1709 15.8059C74.4657 15.745 76.7632 15.7184 79.0585 15.7032L79.059 15.7032C81.7795 15.688 84.5036 15.688 87.2223 15.688H87.223H316.777H316.778C319.5 15.688 322.224 15.688 324.945 15.7032L324.945 15.7032C327.241 15.7184 329.534 15.745 331.833 15.8059L331.833 15.8059C336.835 15.9428 341.901 16.2361 346.879 17.1314M16.8877 749.546L381.934 43.2313L382.379 43.0045C380.077 38.48 377.072 34.3472 373.484 30.7593L373.484 30.7591C369.897 27.1753 365.764 24.1668 361.239 21.8642C356.641 19.5228 351.93 18.039 346.879 17.1314M16.8877 749.546C17.7953 754.601 19.2791 759.316 21.6245 763.919M16.8877 749.546L21.6245 763.919M346.879 17.1314L346.79 17.6235L346.878 17.1314C346.878 17.1314 346.879 17.1314 346.879 17.1314ZM30.5196 776.156C34.1039 779.748 38.2406 782.752 42.7646 785.055C47.3632 787.396 52.0743 788.88 57.1253 789.788C62.0993 790.679 67.168 790.98 72.1709 791.113C74.4657 791.174 76.7632 791.201 79.0585 791.216C81.7797 791.231 84.5041 791.231 87.223 791.231H156.254H248.205H316.777C319.5 791.231 322.224 791.231 324.945 791.216C327.241 791.201 329.534 791.174 331.833 791.113C336.836 790.98 341.901 790.679 346.878 789.788C351.929 788.88 356.641 787.396 361.239 785.055C365.763 782.752 369.896 779.748 373.484 776.156M30.5196 776.156L387.116 57.373C388.008 62.3469 388.305 67.412 388.438 72.4146C388.499 74.7093 388.525 77.0069 388.54 79.2983V79.2988C388.556 82.0234 388.556 84.7439 388.556 87.4667V719.452C388.556 722.175 388.556 724.896 388.54 727.621C388.525 729.912 388.499 732.21 388.438 734.504C388.305 739.507 388.008 744.572 387.116 749.546C386.209 754.601 384.725 759.316 382.379 763.918C380.077 768.439 377.072 772.572 373.484 776.156M30.5196 776.156C26.9316 772.572 23.9269 768.439 21.6245 763.919M30.5196 776.156L21.6245 763.919M373.484 776.156L373.131 775.802L373.485 776.156C373.484 776.156 373.484 776.156 373.484 776.156Z",
    stroke: "black",
    strokeOpacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.589 43.4236C243.199 43.4236 245.314 41.308 245.314 38.6984C245.314 36.0887 243.199 33.9731 240.589 33.9731C237.98 33.9731 235.864 36.0887 235.864 38.6984C235.864 41.308 237.98 43.4236 240.589 43.4236Z",
    fill: "url(#paint11_linear_9553_32422)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.589 43.4236C243.199 43.4236 245.314 41.308 245.314 38.6984C245.314 36.0887 243.199 33.9731 240.589 33.9731C237.98 33.9731 235.864 36.0887 235.864 38.6984C235.864 41.308 237.98 43.4236 240.589 43.4236Z",
    fill: "url(#paint12_linear_9553_32422)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M240.589 44.4236C243.751 44.4236 246.314 41.8603 246.314 38.6984C246.314 35.5364 243.751 32.9731 240.589 32.9731C237.427 32.9731 234.864 35.5364 234.864 38.6984C234.864 41.8603 237.427 44.4236 240.589 44.4236Z",
    stroke: "url(#paint13_linear_9553_32422)",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_dii_9553_32422)"
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.589 41.4547C242.111 41.4547 243.346 40.2206 243.346 38.6983C243.346 37.176 242.111 35.9419 240.589 35.9419C239.067 35.9419 237.833 37.176 237.833 38.6983C237.833 40.2206 239.067 41.4547 240.589 41.4547Z",
    fill: "url(#paint14_linear_9553_32422)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.589 41.4547C242.111 41.4547 243.346 40.2206 243.346 38.6983C243.346 37.176 242.111 35.9419 240.589 35.9419C239.067 35.9419 237.833 37.176 237.833 38.6983C237.833 40.2206 239.067 41.4547 240.589 41.4547Z",
    fill: "url(#paint15_radial_9553_32422)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.589 41.4547C242.111 41.4547 243.346 40.2206 243.346 38.6983C243.346 37.176 242.111 35.9419 240.589 35.9419C239.067 35.9419 237.833 37.176 237.833 38.6983C237.833 40.2206 239.067 41.4547 240.589 41.4547Z",
    fill: "url(#paint16_radial_9553_32422)",
    fillOpacity: 0.6
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.589 41.4547C242.111 41.4547 243.346 40.2206 243.346 38.6983C243.346 37.176 242.111 35.9419 240.589 35.9419C239.067 35.9419 237.833 37.176 237.833 38.6983C237.833 40.2206 239.067 41.4547 240.589 41.4547Z",
    fill: "url(#paint17_radial_9553_32422)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.589 41.4547C242.111 41.4547 243.346 40.2206 243.346 38.6983C243.346 37.176 242.111 35.9419 240.589 35.9419C239.067 35.9419 237.833 37.176 237.833 38.6983C237.833 40.2206 239.067 41.4547 240.589 41.4547Z",
    fill: "url(#paint18_radial_9553_32422)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.589 41.4547C242.111 41.4547 243.346 40.2206 243.346 38.6983C243.346 37.176 242.111 35.9419 240.589 35.9419C239.067 35.9419 237.833 37.176 237.833 38.6983C237.833 40.2206 239.067 41.4547 240.589 41.4547Z",
    fill: "url(#paint19_linear_9553_32422)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M243.096 38.6983C243.096 40.0825 241.973 41.2047 240.589 41.2047C239.205 41.2047 238.083 40.0825 238.083 38.6983C238.083 37.314 239.205 36.1919 240.589 36.1919C241.973 36.1919 243.096 37.314 243.096 38.6983Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 0.5,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.589 39.486C241.024 39.486 241.377 39.1334 241.377 38.6984C241.377 38.2635 241.024 37.9109 240.589 37.9109C240.154 37.9109 239.802 38.2635 239.802 38.6984C239.802 39.1334 240.154 39.486 240.589 39.486Z",
    fill: "white",
    fillOpacity: 0.2,
    style: {
      mixBlendMode: "overlay"
    }
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_9553_32422)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_i_9553_32422)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.49 38.6984C179.49 37.4298 180.518 36.4014 181.786 36.4014H223.132C224.401 36.4014 225.429 37.4298 225.429 38.6984V38.6984C225.429 39.9669 224.401 40.9953 223.132 40.9953H181.786C180.518 40.9953 179.49 39.9669 179.49 38.6984V38.6984Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.49 38.6984C179.49 37.4298 180.518 36.4014 181.786 36.4014H223.132C224.401 36.4014 225.429 37.4298 225.429 38.6984V38.6984C225.429 39.9669 224.401 40.9953 223.132 40.9953H181.786C180.518 40.9953 179.49 39.9669 179.49 38.6984V38.6984Z",
    fill: "url(#pattern0)",
    fillOpacity: 0.02
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.49 38.6984C179.49 37.4298 180.518 36.4014 181.786 36.4014H223.132C224.401 36.4014 225.429 37.4298 225.429 38.6984V38.6984C225.429 39.9669 224.401 40.9953 223.132 40.9953H181.786C180.518 40.9953 179.49 39.9669 179.49 38.6984V38.6984Z",
    fill: "url(#paint20_linear_9553_32422)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M223.132 35.4014H181.786C179.966 35.4014 178.49 36.8775 178.49 38.6984C178.49 40.5192 179.966 41.9953 181.786 41.9953H223.132C224.953 41.9953 226.429 40.5192 226.429 38.6984C226.429 36.8775 224.953 35.4014 223.132 35.4014Z",
    stroke: "url(#paint21_linear_9553_32422)",
    strokeWidth: 2
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7263 726.595V79.4052C29.7263 77.5167 29.7263 75.6308 29.7395 73.7423C29.7474 72.1541 29.7685 70.5632 29.8106 68.975C29.9028 65.5115 30.1082 62.019 30.7219 58.5949C31.3462 55.1182 32.3655 51.8838 33.9748 48.7258C35.5551 45.6205 37.6174 42.7838 40.0801 40.3211C42.5401 37.8611 45.3794 35.7961 48.4848 34.2158C51.6402 32.6091 54.8746 31.5898 58.3486 30.9656C61.7727 30.3492 65.2678 30.1464 68.7314 30.0516C70.3196 30.0095 71.9105 29.991 73.5013 29.9805C75.3872 29.97 77.2757 29.97 79.1615 29.97H100.473C103.518 29.97 105.986 32.4381 105.986 35.4827V37.3203C105.986 48.4839 115.036 57.5338 126.2 57.5338H277.801C288.964 57.5338 298.014 48.4839 298.014 37.3203L298.014 35.4827C298.014 32.4381 300.482 29.97 303.527 29.97H324.839C326.727 29.97 328.616 29.97 330.502 29.9805C332.092 29.991 333.681 30.0095 335.272 30.0516C338.735 30.1464 342.228 30.3492 345.654 30.9656C349.128 31.5898 352.363 32.6091 355.518 34.2158C358.623 35.7961 361.46 37.8611 363.923 40.3211C366.385 42.7838 368.448 45.6205 370.028 48.7258C371.637 51.8838 372.657 55.1182 373.281 58.5949C373.895 62.019 374.1 65.5115 374.192 68.975C374.234 70.5632 374.253 72.1541 374.263 73.7423C374.274 75.6308 374.274 77.5167 374.274 79.4052V726.595C374.274 728.484 374.274 730.37 374.263 732.258C374.253 733.846 374.234 735.437 374.192 737.025C374.1 740.489 373.895 743.981 373.281 747.405C372.657 750.882 371.637 754.119 370.028 757.277C368.448 760.38 366.385 763.217 363.923 765.677C361.46 768.142 358.623 770.204 355.518 771.784C352.363 773.391 349.128 774.41 345.654 775.035C342.228 775.648 338.735 775.857 335.272 775.949C333.681 775.991 332.092 776.009 330.502 776.02C328.616 776.03 326.727 776.03 324.839 776.03H79.1615C77.2757 776.03 75.3872 776.03 73.5013 776.02C71.9105 776.009 70.3196 775.991 68.7314 775.949C65.2678 775.857 61.7727 775.648 58.3486 775.035C54.8746 774.41 51.6402 773.391 48.4848 771.784C45.3794 770.204 42.5401 768.142 40.0801 765.677C37.6174 763.217 35.5551 760.38 33.9748 757.277C32.3655 754.119 31.3462 750.882 30.7219 747.405C30.1082 743.981 29.9028 740.489 29.8106 737.025C29.7685 735.437 29.7474 733.846 29.7395 732.258C29.7263 730.37 29.7263 728.484 29.7263 726.595Z",
    fill: "#252525"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7263 726.595V79.4052C29.7263 77.5167 29.7263 75.6308 29.7395 73.7423C29.7474 72.1541 29.7685 70.5632 29.8106 68.975C29.9028 65.5115 30.1082 62.019 30.7219 58.5949C31.3462 55.1182 32.3655 51.8838 33.9748 48.7258C35.5551 45.6205 37.6174 42.7838 40.0801 40.3211C42.5401 37.8611 45.3794 35.7961 48.4848 34.2158C51.6402 32.6091 54.8746 31.5898 58.3486 30.9656C61.7727 30.3492 65.2678 30.1464 68.7314 30.0516C70.3196 30.0095 71.9105 29.991 73.5013 29.9805C75.3872 29.97 77.2757 29.97 79.1615 29.97H100.473C103.518 29.97 105.986 32.4381 105.986 35.4827V37.3203C105.986 48.4839 115.036 57.5338 126.2 57.5338H277.801C288.964 57.5338 298.014 48.4839 298.014 37.3203L298.014 35.4827C298.014 32.4381 300.482 29.97 303.527 29.97H324.839C326.727 29.97 328.616 29.97 330.502 29.9805C332.092 29.991 333.681 30.0095 335.272 30.0516C338.735 30.1464 342.228 30.3492 345.654 30.9656C349.128 31.5898 352.363 32.6091 355.518 34.2158C358.623 35.7961 361.46 37.8611 363.923 40.3211C366.385 42.7838 368.448 45.6205 370.028 48.7258C371.637 51.8838 372.657 55.1182 373.281 58.5949C373.895 62.019 374.1 65.5115 374.192 68.975C374.234 70.5632 374.253 72.1541 374.263 73.7423C374.274 75.6308 374.274 77.5167 374.274 79.4052V726.595C374.274 728.484 374.274 730.37 374.263 732.258C374.253 733.846 374.234 735.437 374.192 737.025C374.1 740.489 373.895 743.981 373.281 747.405C372.657 750.882 371.637 754.119 370.028 757.277C368.448 760.38 366.385 763.217 363.923 765.677C361.46 768.142 358.623 770.204 355.518 771.784C352.363 773.391 349.128 774.41 345.654 775.035C342.228 775.648 338.735 775.857 335.272 775.949C333.681 775.991 332.092 776.009 330.502 776.02C328.616 776.03 326.727 776.03 324.839 776.03H79.1615C77.2757 776.03 75.3872 776.03 73.5013 776.02C71.9105 776.009 70.3196 775.991 68.7314 775.949C65.2678 775.857 61.7727 775.648 58.3486 775.035C54.8746 774.41 51.6402 773.391 48.4848 771.784C45.3794 770.204 42.5401 768.142 40.0801 765.677C37.6174 763.217 35.5551 760.38 33.9748 757.277C32.3655 754.119 31.3462 750.882 30.7219 747.405C30.1082 743.981 29.9028 740.489 29.8106 737.025C29.7685 735.437 29.7474 733.846 29.7395 732.258C29.7263 730.37 29.7263 728.484 29.7263 726.595Z",
    fill: "url(#pattern1)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3464 29.0049C46.598 29.0049 30.5889 45.0141 30.5889 64.7624V737.737C30.5889 757.485 46.598 773.495 66.3464 773.495H338.654C358.402 773.495 374.411 757.485 374.411 737.737V64.7624C374.411 45.0141 358.402 29.0049 338.654 29.0049H306.563C301.062 29.0049 298.312 29.9217 298.312 36.3398C298.312 48.2589 290.06 56.5107 277.224 56.5107H127.776C114.94 56.5107 106.688 48.2589 106.688 36.3398C106.688 29.9217 103.938 29.0049 98.4364 29.0049H66.3464Z",
    fill: "#FCFCFC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9443 87.4666V719.452C15.9443 722.175 15.9443 724.894 15.9633 727.617C15.9747 729.907 16.0051 732.201 16.0659 734.491C16.1988 739.485 16.495 744.521 17.3799 749.458C18.2799 754.471 19.7496 759.138 22.07 763.691C24.3486 768.165 27.3222 772.255 30.873 775.802C34.42 779.357 38.5139 782.331 42.9914 784.609C47.541 786.926 52.2046 788.395 57.2137 789.295C62.1507 790.18 67.1902 790.48 72.1842 790.613C74.4742 790.674 76.768 790.701 79.0618 790.716C81.7809 790.731 84.5039 790.731 87.223 790.731H156.254H248.205H316.777C319.5 790.731 322.223 790.731 324.942 790.716C327.236 790.701 329.526 790.674 331.82 790.613C336.814 790.48 341.849 790.18 346.79 789.295C351.799 788.395 356.463 786.926 361.012 784.609C365.49 782.331 369.58 779.357 373.131 775.802C376.682 772.255 379.655 768.165 381.934 763.691C384.254 759.138 385.724 754.471 386.624 749.458C387.509 744.521 387.805 739.485 387.938 734.491C387.999 732.201 388.025 729.907 388.041 727.617C388.056 724.894 388.056 722.175 388.056 719.452V87.4666C388.056 84.7437 388.056 82.0246 388.041 79.3016C388.025 77.0116 387.999 74.7178 387.938 72.4278C387.805 67.4339 387.509 62.3982 386.624 57.4612C385.724 52.4482 384.254 47.7847 381.934 43.2313C379.655 38.7538 376.682 34.6637 373.131 31.1129C369.58 27.5658 365.49 24.5885 361.012 22.3098C356.463 19.9933 351.799 18.5236 346.79 17.6235C341.849 16.7349 336.814 16.4424 331.82 16.3057C329.526 16.245 327.236 16.2184 324.942 16.2032C322.223 16.188 319.5 16.188 316.777 16.188H87.223C84.5039 16.188 81.7809 16.188 79.0618 16.2032C76.768 16.2184 74.4742 16.245 72.1842 16.3057C67.1902 16.4424 62.1507 16.7349 57.2137 17.6235C52.2046 18.5236 47.541 19.9933 42.9914 22.3098C38.5139 24.5885 34.42 27.5658 30.873 31.1129C27.3222 34.6637 24.3486 38.7538 22.07 43.2313C19.7496 47.7847 18.2799 52.4482 17.3799 57.4612C16.495 62.3982 16.1988 67.4339 16.0659 72.4278C16.0051 74.7178 15.9747 77.0116 15.9633 79.3016C15.9443 82.0246 15.9443 84.7437 15.9443 87.4666Z",
    fill: "url(#paint22_linear_9553_32422)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9553_32422",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 16,
    width: 374,
    height: 775
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9443 87.4666V719.452C15.9443 722.175 15.9443 724.894 15.9633 727.617C15.9747 729.907 16.0051 732.201 16.0659 734.491C16.1988 739.485 16.495 744.521 17.3799 749.458C18.2799 754.471 19.7496 759.138 22.07 763.691C24.3486 768.165 27.3222 772.255 30.873 775.802C34.42 779.357 38.5139 782.331 42.9914 784.609C47.541 786.926 52.2046 788.395 57.2137 789.295C62.1507 790.18 67.1902 790.48 72.1842 790.613C74.4742 790.674 76.768 790.701 79.0618 790.716C81.7809 790.731 84.5039 790.731 87.223 790.731H156.254H248.205H316.777C319.5 790.731 322.223 790.731 324.942 790.716C327.236 790.701 329.526 790.674 331.82 790.613C336.814 790.48 341.849 790.18 346.79 789.295C351.799 788.395 356.463 786.926 361.012 784.609C365.49 782.331 369.58 779.357 373.131 775.802C376.682 772.255 379.655 768.165 381.934 763.691C384.254 759.138 385.724 754.471 386.624 749.458C387.509 744.521 387.805 739.485 387.938 734.491C387.999 732.201 388.025 729.907 388.041 727.617C388.056 724.894 388.056 722.175 388.056 719.452V87.4666C388.056 84.7437 388.056 82.0246 388.041 79.3016C388.025 77.0116 387.999 74.7178 387.938 72.4278C387.805 67.4339 387.509 62.3982 386.624 57.4612C385.724 52.4482 384.254 47.7847 381.934 43.2313C379.655 38.7538 376.682 34.6637 373.131 31.1129C369.58 27.5658 365.49 24.5885 361.012 22.3098C356.463 19.9933 351.799 18.5236 346.79 17.6235C341.849 16.7349 336.814 16.4424 331.82 16.3057C329.526 16.245 327.236 16.2184 324.942 16.2032C322.223 16.188 319.5 16.188 316.777 16.188H87.223C84.5039 16.188 81.7809 16.188 79.0618 16.2032C76.768 16.2184 74.4742 16.245 72.1842 16.3057C67.1902 16.4424 62.1507 16.7349 57.2137 17.6235C52.2046 18.5236 47.541 19.9933 42.9914 22.3098C38.5139 24.5885 34.42 27.5658 30.873 31.1129C27.3222 34.6637 24.3486 38.7538 22.07 43.2313C19.7496 47.7847 18.2799 52.4482 17.3799 57.4612C16.495 62.3982 16.1988 67.4339 16.0659 72.4278C16.0051 74.7178 15.9747 77.0116 15.9633 79.3016C15.9443 82.0246 15.9443 84.7437 15.9443 87.4666Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9553_32422)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_i_9553_32422)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3741 63.1132V740.047C22.3741 758.189 33.9075 776.374 32.7123 777.638C30.8747 776.719 24.6728 769.369 21.2274 761.559C18.2427 754.794 16.174 748.466 15.9443 732.847L15.9443 72.9234C15.2552 40.5359 35.109 26.2946 36.3364 27.3058C38.0702 28.7342 22.3741 42.4433 22.3741 63.1132Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3741 63.1132V740.047C22.3741 758.189 33.9075 776.374 32.7123 777.638C30.8747 776.719 24.6728 769.369 21.2274 761.559C18.2427 754.794 16.174 748.466 15.9443 732.847L15.9443 72.9234C15.2552 40.5359 35.109 26.2946 36.3364 27.3058C38.0702 28.7342 22.3741 42.4433 22.3741 63.1132Z",
    fill: "url(#paint23_linear_9553_32422)",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_i_9553_32422)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M382.949 70.923L383.868 737.751C383.868 744.694 382.805 752.185 380.705 757.884C376.371 769.653 370.252 777.705 371.058 777.638C375.193 773.963 380.476 767.795 383.868 759.262C385.529 754.439 387.596 750.534 387.826 736.522L388.46 70.9232C388.46 58.1753 383.814 39.0397 369.718 28.1096C367.985 26.7651 382.949 50.2531 382.949 70.923Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M382.949 70.923L383.868 737.751C383.868 744.694 382.805 752.185 380.705 757.884C376.371 769.653 370.252 777.705 371.058 777.638C375.193 773.963 380.476 767.795 383.868 759.262C385.529 754.439 387.596 750.534 387.826 736.522L388.46 70.9232C388.46 58.1753 383.814 39.0397 369.718 28.1096C367.985 26.7651 382.949 50.2531 382.949 70.923Z",
    fill: "url(#paint24_linear_9553_32422)",
    fillOpacity: 0.8
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_9553_32422",
    x: 3,
    y: 116.121,
    width: 3,
    height: 25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_9553_32422"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_9553_32422",
    x: 2,
    y: 113.121,
    width: 10,
    height: 31,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.12549 0 0 0 0 0.121569 0 0 0 0 0.133333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_9553_32422"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_9553_32422",
    x: 397,
    y: 192.381,
    width: 3,
    height: 85,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_9553_32422"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_9553_32422",
    x: 390,
    y: 189.381,
    width: 10,
    height: 91,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.12549 0 0 0 0 0.121569 0 0 0 0 0.133333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_9553_32422"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_9553_32422",
    x: 3,
    y: 174.005,
    width: 3,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_9553_32422"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_9553_32422",
    x: 2,
    y: 171.005,
    width: 10,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.12549 0 0 0 0 0.121569 0 0 0 0 0.133333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_9553_32422"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_9553_32422",
    x: 3,
    y: 247.508,
    width: 3,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_9553_32422"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i_9553_32422",
    x: 2,
    y: 244.508,
    width: 10,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.12549 0 0 0 0 0.121569 0 0 0 0 0.133333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_9553_32422"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_ii_9553_32422",
    x: 6.75635,
    y: 7,
    width: 394.487,
    height: 795.919,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_9553_32422"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_9553_32422",
    result: "effect2_innerShadow_9553_32422"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_9553_32422",
    x: -2.39331,
    y: 15.9492,
    width: 53.2749,
    height: 52.4399,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_9553_32422"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_9553_32422",
    x: -3.31226,
    y: 734.212,
    width: 53.2751,
    height: 52.4399,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_9553_32422"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_9553_32422",
    x: 353.686,
    y: 15.9492,
    width: 53.2749,
    height: 52.4397,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_9553_32422"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_f_9553_32422",
    x: 354.145,
    y: 734.212,
    width: 53.2749,
    height: 52.4397,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_9553_32422"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_ddddi_9553_32422",
    x: 0.187988,
    y: 0.431641,
    width: 407.624,
    height: 806.056,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.629167 0 0 0 0 0.629167 0 0 0 0 0.629167 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9553_32422"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_9553_32422",
    result: "effect2_dropShadow_9553_32422"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_9553_32422",
    result: "effect3_dropShadow_9553_32422"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_9553_32422",
    result: "effect4_dropShadow_9553_32422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_9553_32422",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect5_innerShadow_9553_32422"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_i_9553_32422",
    x: 14.9443,
    y: 15.188,
    width: 374.111,
    height: 786.543,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_9553_32422"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_dii_9553_32422",
    x: 235.833,
    y: 34.9419,
    width: 9.5127,
    height: 9.5127,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9553_32422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9553_32422",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_9553_32422"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_9553_32422",
    result: "effect3_innerShadow_9553_32422"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_i_9553_32422",
    x: 177.49,
    y: 34.4014,
    width: 49.9397,
    height: 12.594,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_9553_32422"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 0.108838,
    height: 1.08838
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_9553_32422",
    transform: "scale(0.0017006 0.017006)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_9553_32422",
    transform: "scale(0.00133333 0.000615764)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_i_9553_32422",
    x: 15.9268,
    y: 27.2556,
    width: 21.5435,
    height: 750.382,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_9553_32422"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_i_9553_32422",
    x: 369.579,
    y: 28.0544,
    width: 19.8813,
    height: 749.584,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_9553_32422"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9553_32422",
    x1: 5,
    y1: 116.121,
    x2: 5,
    y2: 141.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9553_32422",
    x1: 8,
    y1: 113.576,
    x2: 8,
    y2: 143.665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030649,
    stopColor: "#201F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0912771,
    stopColor: "#201F22",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.910238,
    stopColor: "#201F22",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969904,
    stopColor: "#201F22",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9553_32422",
    x1: 1,
    y1: 0,
    x2: 1,
    y2: 85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9553_32422",
    x1: 396,
    y1: 190.719,
    x2: 396,
    y2: 279.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030649,
    stopColor: "#201F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0912771,
    stopColor: "#201F22",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.910238,
    stopColor: "#201F22",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969904,
    stopColor: "#201F22",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9553_32422",
    x1: 5,
    y1: 174.005,
    x2: 5,
    y2: 224.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9553_32422",
    x1: 8,
    y1: 171.828,
    x2: 8,
    y2: 226.181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030649,
    stopColor: "#201F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0912771,
    stopColor: "#201F22",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.910238,
    stopColor: "#201F22",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969904,
    stopColor: "#201F22",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_9553_32422",
    x1: 5,
    y1: 247.508,
    x2: 5,
    y2: 297.508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_9553_32422",
    x1: 8,
    y1: 245.332,
    x2: 8,
    y2: 299.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030649,
    stopColor: "#201F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0912771,
    stopColor: "#201F22",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.910238,
    stopColor: "#201F22",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969904,
    stopColor: "#201F22",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_9553_32422",
    x1: 6.75635,
    y1: 7,
    x2: 397.244,
    y2: 799.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.612097,
    stopColor: "#595560",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_9553_32422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(397.244 6.99999) rotate(139.905) scale(284.956 140.332)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171212",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_9553_32422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.2761 738.819) rotate(128.598) scale(67.0105 33.0005)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.719628,
    stopColor: "#EAE7E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9C3B1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_9553_32422",
    x1: 250.04,
    y1: 38.6984,
    x2: 240.589,
    y2: 29.2479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E3235"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.393056,
    stopColor: "#232426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_9553_32422",
    x1: 232.967,
    y1: 39.7138,
    x2: 242.161,
    y2: 48.0205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopOpacity: 0.5001
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_9553_32422",
    x1: 239.211,
    y1: 36.5326,
    x2: 244.527,
    y2: 42.4392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3F3F",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F3F",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_9553_32422",
    x1: 237.833,
    y1: 35.9419,
    x2: 237.833,
    y2: 41.4547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#062F90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#012576"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_9553_32422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(240.859 38.6983) rotate(119.459) scale(2.06925 6.54915)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#031749"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856633,
    stopColor: "#010D1E",
    stopOpacity: 0.13912
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010B17",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_9553_32422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(241.275 37.1592) rotate(125.913) scale(1.16898 2.0034)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C84FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C85AD",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_9553_32422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(238.612 38.17) rotate(90) scale(1.16667 1.16667)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_9553_32422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(243.346 39.6302) rotate(22.2593) scale(1.37484 1.7342)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C86FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3901,
    stopColor: "#0A9DFF",
    stopOpacity: 0.371533
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ABFF",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_9553_32422",
    x1: 237.833,
    y1: 35.9419,
    x2: 237.833,
    y2: 41.4547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5200FF",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B800FF",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_9553_32422",
    x1: 179.49,
    y1: 38.6983,
    x2: 225.429,
    y2: 38.6984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_9553_32422",
    x1: 202.459,
    y1: 41.6844,
    x2: 202.459,
    y2: 35.7123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3C3C",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_9553_32422",
    x1: 11.5801,
    y1: 16.188,
    x2: 388.056,
    y2: 790.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.471233,
    stopColor: "white",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_9553_32422",
    x1: 16.8631,
    y1: 698.592,
    x2: 32.5251,
    y2: 698.592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_9553_32422",
    x1: 388.46,
    y1: 701.185,
    x2: 373.378,
    y2: 701.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9553_32422"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.67517,
    height: 31.239,
    fill: "white",
    transform: "translate(4 113.121)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9553_32422"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.67517,
    height: 90.9606,
    fill: "white",
    transform: "matrix(-1 0 0 1 400 189.381)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_9553_32422"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.67517,
    height: 56.0464,
    fill: "white",
    transform: "translate(4 171.005)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_9553_32422"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.67517,
    height: 56.0464,
    fill: "white",
    transform: "translate(4 244.508)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_9553_32422"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.7772,
    height: 6.43156,
    fill: "white",
    transform: "translate(178.571 35.4827)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_9553_32422",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAA40lEQVR4Xu3bQQ6EQAhEUbj/oXsO8Sdh4XOvJAi/qkF3Zt6E6710++xuiD6T40uACtACqYlzD2IACFKBkoHcgmSQDJJBMngKIT6ADygF6DSYfcCLTzg/z0eGrASogDbT0gKxB2MB5pkiBoBgrEEMwIBjLx9fAAiCIAhygmkkRgYjhWMHditsL2AvYC+QIHjdwzk+BmAABmBAWc1kCF0bKRAEQRAEQRAMGaACbaCUz/P5BRiKxhQaiV07uRjfYgQDMKDpGAhGCMUCzD4CBEEw1iAGYIBPZMJh+g8/P8cKpAJfV4EfMee/sLtaEFIAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_9553_32422",
    width: 750,
    height: 1624,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAu4AAAZYAQMAAADzD9XyAAAABlBMVEUkJCQpKSkTIzWqAAACeUlEQVR4Ae3ZpxVCUQAFwSVIUkdQOnQEnlTCj3LsC+Pv2U3V9V6vS+3e1WbNAzwej8fj8Xg8Ho8fy/+qx63Oz/rsqzUPDng8Ho/H4/F4PB4/ljfd8Hg8Ho/H4/F4vHaCx+PxeDwej8fj8doJHo/H4/F4PB6P107weDwej8fj8Xg8XjvB4/F4PB6Px+Px2gkej8fj8Xg8Ho/Hayd4PB6Px+PxeDxeO8Hj8Xg8Ho/H4/F47QSPn87j8Xg8Ho/H47UTPB6Px+PxeDwejzfd8Hg8Ho/H4/F4vHaCx+PxeDwej8fj8doJHo/H4/F4PB6P107weDwej8fj8Xg8XjvB4/F4PB6Px+Px2gkej8fj8Xg8Ho/Hayd4PB6Px+PxeDxeO8Hj8Xg8Ho/H4/F47QSPn87j8Xg8Ho/H47UTPB6Px+PxeDwejzfd8Hg8Ho/H4/F4vHaCx+PxeDwej8fj8doJHo/H4/F4PB6P107weDwej8fj8Xg8XjvB4/F4PB6Px+Px2gkej8fj8Xg8Ho/Hayd4PB6Px+PxeDxeO8Hj8Xg8Ho/H4/F47QSPx+PxeDwej8dP1bQTPB6Px+PxeDwej9dO8Hg8Ho/H4/F4vHaCx+PxeDwej8fj8doJHo/H4/F4PB6P107weDwej8fj8Xg8XjvB4/F4PB6Px+Px2gkej8fj8Xg8Ho/Hayd4PB6Px+Px+EEej9dO8Hg8Ho/H4/F4PF47wePxeDwej8fj8doJHo/H4/F4PB6Px2sneDwej8fj8Xg8XjvB4/F4PB6Px+PxeO0Ej8fj8Xg8Ho/Hayd4PB6Px+PxeDwer53g8Xg8Ho/H4/H4Zbx2gsfj8Xg8Ho//A/r/oG7T9gGDAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCase);
export default __webpack_public_path__ + "static/media/phone-case.af2adaa7578b7709378842009ef0b490.svg";
export { ForwardRef as ReactComponent };